import untypedValidateUserTestResponses from '../validate/generated/userTestResponses/validate';
const validateUserTestResponses = ((userTestResponses) => {
    const result = untypedValidateUserTestResponses(userTestResponses, undefined);
    validateUserTestResponses.errors = untypedValidateUserTestResponses.errors;
    return result;
});
export { validateUserTestResponses };
